module.exports = __webpack_public_path__ + "img/ThumbUpOutlined.b0ae66e9.svg";